/*  Shared  */
import { debug } from 'application/Shared/Utils';

/*  Packages  */
import axios from 'axios';

class Requests {
    constructor() {
        this.cancelToken = axios.CancelToken.source();
    }

    cancel() {
        try {
            this.cancelToken.cancel('Cancelling requests');
            this.cancelToken = axios.CancelToken.source();
        } catch (e) {
            debug.e(`Unable to cancel Requests:`, e);
        }
    }

    token() {
        return this.cancelToken.token;
    }
}

export default Requests;
